import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { trackNavigationClick, trackBookingClick } from '../utils/analytics';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/">
          <img 
            src="https://customer-assets.emergentagent.com/job_e76c0267-8aa9-430d-8c3c-8b45ddb37a9a/artifacts/jhvm0afx_Sereno%20logo%20DS%20cropped%20no%20background.png" 
            alt="Sereno Spa" 
            className="logo"
          />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          <ul className="nav">
            <li><Link to="/about" onClick={() => trackNavigationClick('About')}>About</Link></li>
            <li><Link to="/services" onClick={() => trackNavigationClick('Services')}>Services</Link></li>
            <li><Link to="/products" onClick={() => trackNavigationClick('Products')}>Products</Link></li>
            <li><a href="https://www.fresha.com/book-now/sereno-spa-xw34dhed/gift-cards?share=true&pId=2492446" target="_blank" rel="noopener noreferrer" onClick={() => trackNavigationClick('Gift Cards')}>Gift Cards</a></li>
            <li><a href="https://www.fresha.com/book-now/sereno-spa-xw34dhed/services?lid=2572885&share=true&pId=2492446" target="_blank" rel="noopener noreferrer" onClick={() => trackBookingClick('General Booking', 'Header Navigation')}>Book Now</a></li>
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="mobile-nav">
            <ul className="mobile-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/products" onClick={toggleMenu}>Products</Link></li>
              <li><a href="https://www.fresha.com/book-now/sereno-spa-xw34dhed/gift-cards?share=true&pId=2492446" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>Gift Cards</a></li>
              <li><a href="https://www.fresha.com/book-now/sereno-spa-xw34dhed/services?lid=2572885&share=true&pId=2492446" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>Book Now</a></li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;